import React, { Component } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";
import API from "../../API";
import './ProjectCategory.css';
import Cookies from 'js-cookie';
import {Helmet} from "react-helmet";
import Main from "../../layout/main";
import {Col, Container, Row} from "reactstrap";
class ProjectCategory extends Component {
    constructor(props) {
        super(props);
        const service_id = this.props.match.params.id;
        this.state = {
            service_id,
            service: this.props.location.service_data,
        };
    }
    componentDidMount() {
        if (this.state.service == null){
            axios.get(API.baseURL + `/project_sub_types?projecttype_id=${this.state.service_id}`,API.options).then(response => response.data).then(res => {
                this.setState({ service: res });
            });
        }
    }
    render() {
        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <meta name="description"
                          content="Check out all your Data about EasyBids at a single place.The projects you bidded,avaible projects around locality  and the bids approved.Check everything at a single place"/>
                    <title>EasyBids - Home Improvements :: Post Your Project</title>
                </Helmet>
                <Main additionalClass_main="dashboard pt-0">
                    <section className="ebw-section__pages">
                        <Container>
                            <Row >
                                <Col sm="12" md={{size: 10, offset: 1}} lg={{size: 8, offset: 2}}>
                                    {this.state.service ? (
                                        <div className="">
                                            <div className="project-category-title ec-title">Select your project type</div>
                                            <div className="project-category-cards">
                                                {this.state.service.project_sub_types && this.state.service.project_sub_types.length > 0 ? (
                                                    this.state.service.project_sub_types.map((sub_service) => (
                                                        <Link
                                                            to={`/projects/project-form/${this.state.service_id}/${sub_service.id}`}
                                                            className="project-category-card ec-card ec-card__tertiary"
                                                            key={sub_service.id}
                                                            style={{
                                                                transition: 'background-color 0.4s ease',
                                                            }}
                                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                                                        >
                                                            <div className="d-flex">
                                                                <div className="project-category-card-image-container">
                                                                    <img
                                                                        className="project-category-card-image"
                                                                        src={sub_service.image.url}
                                                                        alt={sub_service.name}
                                                                    />
                                                                </div>
                                                                <div className="project-category-card-content">
                                                                    <div>
                                                                        <div className="ec-card__tertiary-title mb-2"
                                                                             style={{fontWeight: 'bold', fontSize: '1.2rem'}}>
                                                                            {sub_service.name}
                                                                        </div>
                                                                        <div
                                                                            className="ec-card__tertiary-para ec-card__tertiary-para--trim2">
                                                                            {sub_service.description}
                                                                        </div>
                                                                    </div>
                                                                    {/* <div className="text-right">
                                                                <span className="ec-btn--tertiary ec-card__tertiary-btn" style={{ color: '#007bff' }}>
                                                                    Select
                                                                </span>
                                                            </div> */}
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    ))
                                                ) : (
                                                    <div className="text-center w-100">
                                                        <h3>No services available</h3>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="d-flex justify-content-center align-items-center h-100">
                                            <h3>Loading...</h3>
                                        </div>
                                    )}
                                </Col>
                            </Row>
                        </Container>
                    </section>
                </Main>
            </div>
        );
    }
}

export default ProjectCategory;